import UpliftWidget from '@/components/UpliftWidget/UpliftWidget';
import { UPLIFT_EMPTY_LEG_GUID } from '@/config/uplift.config';

import styles from './emptyLeg.module.scss';

const EmptyLegComponent = () => {
  return (
    <section className="container">
      <div className={styles.emptyLegSection}>
        <h2 className={styles.sectionTitle}>
          Hera Flight empty legs include the available empty legs on our
          Network, and are updated daily with the latest prices and empty legs
          availability.
        </h2>
        <div className={styles.emptyLegWrapper}>
          {/* <iframe
            className=" lazyloaded"
            style={{ border: 'none' }}
            data-src="https://client.jetinsight.com/embed/8c9e386f-6269-447d-b45e-5b52c2e605c3/empty"
            height="900px"
            width="100%"
            src="https://client.jetinsight.com/embed/8c9e386f-6269-447d-b45e-5b52c2e605c3/empty"
          ></iframe> */}
          <h2 className={styles.upliftTitle}>
            Additional empty legs with instant pricing.
          </h2>
          <UpliftWidget guid={UPLIFT_EMPTY_LEG_GUID} tall />
        </div>

        <div className={styles.bottomText}>
          *Availability is subject to change, please inquire with your Dedicated
          Advisor to confirm. Taxes and FES not included. Due to the nature of
          these flights we are unable to confirm availability and/or pricing
          until 48 hours prior to departure time.
        </div>
      </div>
    </section>
  );
};

export default EmptyLegComponent;
